import React from 'react';
import { Modal } from 'react-bootstrap';
import { IconTrash, IconX } from '@tabler/icons-react';
import PropTypes from 'prop-types';
import './DeletePaymentMethodModal.css';

const DeletePaymentMethodModal = ({
  isOpen,
  onClose,
  onConfirmDelete,
  paymentMethod = null,
  isDeleting = false,
  isDefaultMethod = false,
}) => {
  // Get card brand display name
  const getCardBrandDisplay = (brand) => {
    const brandMap = {
      visa: 'Visa',
      mastercard: 'Mastercard',
      amex: 'American Express',
      discover: 'Discover',
      diners: 'Diners Club',
      jcb: 'JCB',
      unionpay: 'UnionPay',
    };
    return brandMap[brand?.toLowerCase()] || brand?.toUpperCase() || 'Card';
  };

  const cardBrand = paymentMethod?.card?.brand 
    ? getCardBrandDisplay(paymentMethod.card.brand)
    : 'Card';
  const last4 = paymentMethod?.card?.last4 || '****';

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
      backdrop="static"
      className="modern-modal"
    >
      <Modal.Header className="delete-modal-header">
        <Modal.Title>Delete Payment Method</Modal.Title>
        <button
          type="button"
          className="modal-close-btn"
          onClick={onClose}
          disabled={isDeleting}
          aria-label="Close"
        >
          <IconX size={20} />
        </button>
      </Modal.Header>

      <Modal.Body>
        <div className="delete-modal-content">
          <div className="delete-modal-icon">
            <IconTrash size={24} />
          </div>
          <h3 className="delete-modal-title">
            Are you sure you want to delete this payment method?
          </h3>
          <p className="delete-modal-description">
            You are about to delete <strong>{cardBrand}</strong> ending in{' '}
            <strong>{last4}</strong>. This action cannot be undone.
          </p>
          {isDefaultMethod && (
            <div className="delete-modal-warning">
              <strong>Note:</strong> This is your default payment method. Please set 
              another card as default before deleting this one.
            </div>
          )}
        </div>
      </Modal.Body>

      <Modal.Footer className="modern-modal-footer">
        <button
          type="button"
          className="btn-modern btn-modern-cancel"
          onClick={onClose}
          disabled={isDeleting}
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn-modern btn-modern-danger"
          onClick={onConfirmDelete}
          disabled={isDeleting || isDefaultMethod}
        >
          {isDeleting ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              Deleting...
            </>
          ) : (
            'Delete'
          )}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

DeletePaymentMethodModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirmDelete: PropTypes.func.isRequired,
  paymentMethod: PropTypes.object,
  isDeleting: PropTypes.bool,
  isDefaultMethod: PropTypes.bool,
};

export default DeletePaymentMethodModal;
